import "./GrassPatch.css"
export function GrassPatch({ left, bottom = 0, scale = 1, delay = 0 }) {
  const publicUrl = process.env.PUBLIC_URL || "";
  return (
    <div
      className="grass-patch"
      style={{
        left,
        bottom,
        transform: `scale(${scale})`,
        animationDelay: `${delay}s`,
        backgroundImage: `url('${publicUrl}/assets/grass.svg')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "contain",
      }}
    />
  );
}
